export enum STATICIMAGEEXTENSIONS {
    PNG = 'png',
    WEBP = 'webp',
}